/**
 * 权限常量定义
 * 区分菜单权限和按钮权限
 */

// 菜单权限
export const MENU = {
  // 现有权限
  DASHBOARD: 'dashboard:menu',      // 仪表盘
  SYSTEM: 'system:menu',            // 系统管理
  REWARD: 'reward:menu',            // 赏金管理
  COMMUNICATION: 'communication:menu', // 通信管理
  PROFILE: 'profile:menu', // 个人中心

  // 新增模块权限
  PRODUCT_MANAGEMENT: 'product:management:menu', // 商品管理
  PRODUCT_SHOP: 'product:shop:menu', // 店铺管理
  LOGISTICS_MANAGEMENT: 'logistics:management:menu', // 物流管理
  ORDER_MANAGEMENT: 'order:management:menu', // 订单管理
  ORDER_SHIPPING: 'order:shipping:menu', // 发货中心
  ORDER_QUALITY: 'order:quality:menu', // 质检中心
  SERVICE_MANAGEMENT: 'service:management:menu', // 服务管理
  SERVICE_CUSTOM: 'service:custom:menu', // 定制服务
  SERVICE_ACCOMPANY: 'service:accompany:menu', // 陪逛服务
  SERVICE_PLATFORM_SALES: 'service:platform-sales:menu', // 平台代售
  AFTER_SALE_SERVICE: 'after-sale-service:menu', // 售后服务管理
  HELP_CENTER: 'help:center:menu', // 帮助中心
  SHOPPING_CART: 'shopping:cart:menu', // 购物车管理
  USER_ADDRESS: 'user:address:menu', // 地址管理
  LIKE_MANAGEMENT: 'like:management:menu', // 点赞管理
  INTERACTION_MESSAGE: 'interaction:message:menu', // 互动消息管理


  // 系统管理子菜单
  SYSTEM_USER: 'system:user:menu',  // 用户管理
  SYSTEM_ROLE: 'system:role:menu',  // 角色管理
  SYSTEM_PERMISSION: 'system:permission:menu', // 权限管理
  SYSTEM_LOG: 'system:log:menu',    // 日志管理
  SYSTEM_OPERATION_LOG: 'system:operation-log:menu',    // 系统操作日志
  SYSTEM_ERROR_LOG: 'system:error-log:menu',    // 系统错误日志
  SYSTEM_SETTINGS: 'system:settings:menu', // 系统设置
  BANNER_MANAGEMENT: 'banner:menu', // 轮播图管理

  // 赏金管理子菜单
  REWARD_USER: 'reward:user:menu',  // 用户信息管理
  REWARD_FINANCE: 'reward:finance:menu', // 财务管理
  REWARD_VERIFICATION: 'reward:verification:menu', // 认证管理
  REWARD_ACCOUNT: 'reward:account:menu', // 用户账户管理
  REWARD_LOGIN: 'reward:login:menu', // 登录管理
  
  // 通信管理子菜单
  COMMUNICATION_NOTIFICATION: 'communication:notification:menu', // 系统通知管理
  COMMUNICATION_CHAT: 'communication:chat:menu', // 聊天消息管理
  COMMUNICATION_PUSH: 'communication:push:menu', // 消息推送管理
  COMMUNICATION_FEEDBACK: 'complaint-feedback:menu', // 反馈管理
  
  // 财务管理子菜单
  REWARD_FINANCE_WITHDRAW: 'reward:finance:withdraw:menu', // 提现管理
  REWARD_FINANCE_TRANSACTION: 'reward:finance:transaction:menu', // 交易记录
  REWARD_FINANCE_ORDER: 'reward:finance:order:menu', // 订单管理
  REWARD_FINANCE_PRECHARGE: 'reward:finance:precharge:menu', // 预充值订单管理
  REWARD_FINANCE_FREEZE_RECORD: 'reward:finance:freeze:record:menu', // 账户冻结记录管理
  REWARD_FINANCE_PAYMENT: 'reward:finance:payment:menu', // 支付接口集成

  // 认证管理子菜单
  REWARD_VERIFICATION_USER: 'reward:verification:user:menu', // 用户认证
  REWARD_VERIFICATION_BUSINESS: 'reward:verification:business:menu', // 企业认证

  //求购与动态菜单
  PURCHASE_AND_DYNAMICS: 'purchase:and:dynamics:menu', // 求购与动态
  
  // 资讯管理菜单
  ARTICLE_MANAGEMENT: 'article:menu', // 资讯文章管理
  ARTICLE_TYPE_MANAGEMENT: 'article-type:menu', // 资讯文章类型管理
  // 玉石鉴定知识文章管理菜单
  JADE_IDENTIFICATION_ARTICLE_MANAGEMENT: 'jade-identification-article:menu', // 玉石鉴定知识文章管理
  ARTICLE_REDEEM_CODE: 'article-redeem-code:menu', // 付费文章兑换码管理
  USER_ARTICLE_REDEEM: 'user-article-redeem:menu', // 用户付费文章服务兑换管理

  // 店铺访问统计菜单
  STORE_VISIT_STATISTICS_MENU: 'store-visit-statistics:menu', // 店铺访问统计
  
  // 玉石鉴定服务管理菜单
  JADE_IDENTIFICATION_SERVICE: 'jade-identification-service:menu', // 玉石鉴定服务管理
  // 玉石鉴定分类管理菜单
  JADE_IDENTIFICATION_CATEGORY: 'jade-identification-category:menu', // 玉石鉴定分类管理
  // 玉石鉴定订单管理菜单
  JADE_IDENTIFICATION_ORDER: 'jade-identification-order:menu', // 玉石鉴定订单管理
};

// 系统管理按钮权限
export const SYSTEM = {
  // 用户管理
  USER: {
    LIST: 'system:user:list',       // 用户列表
    CREATE: 'system:user:create',   // 创建用户
    UPDATE: 'system:user:update',   // 更新用户 启用 禁用
    DELETE: 'system:user:delete',   // 删除用户
    DETAIL: 'system:user:detail',   // 用户详情
    EXPORT: 'system:user:export',   // 导出用户
    IMPORT: 'system:user:import',   // 导入用户
    ASSIGN_ROLE: 'system:user:assign-role',  // 分配角色
    RESET_PWD: 'system:admin:reset', // 重置密码
    CREATE_ADMIN: 'system:admin:create', // 创建管理员
    UPDATE_ADMIN: 'system:admin:update', // 更新管理员
    EXPORT_ADMIN: 'system:admin:export', // 导出管理员
    IMPORT_ADMIN: 'system:admin:import', // 导入管理员
    
  },
  
  // 角色管理
  ROLE: {
    LIST: 'system:role:list',       // 角色列表
    CREATE: 'system:role:create',   // 创建角色 
    UPDATE: 'system:role:update',   // 更新角色 分配权限
    DELETE: 'system:role:delete',   // 删除角色
    DETAIL: 'system:role:detail',   // 角色详情
    ASSIGN_PERM: 'system:role:assign-permission', // 分配权限
  },
  
  // 权限管理
  PERMISSION: {
    LIST: 'system:permission:list',     // 权限列表
    CREATE: 'system:permission:create', // 创建权限
    UPDATE: 'system:permission:update', // 更新权限
    DELETE: 'system:permission:delete', // 删除权限
    DETAIL: 'system:permission:detail', // 权限详情
  },
  
  // 日志管理
  LOG: {
    OPERATION: {
      LIST: 'system:log:operation:list',    // 操作日志列表
      DETAIL: 'system:log:operation:detail', // 操作日志详情
      EXPORT: 'system:log:operation:export', // 导出操作日志
      CLEAR: 'system:log:operation:clear',   // 清空操作日志
    },
  },
  
  // 系统操作日志
  SYSTEM_OPERATION_LOG: {
    LIST: 'system:operation-log:list',    // 系统操作日志列表
    DETAIL: 'system:operation-log:detail', // 系统操作日志详情
  },
  
  // 系统错误日志
  SYSTEM_ERROR_LOG: {
    LIST: 'system:error-log:list',    // 系统错误日志列表
    DETAIL: 'system:error-log:detail', // 系统错误日志详情
  },

  // 系统设置
  SETTINGS: {
    VIEW: 'system-config:list',       // 查看设置
    UPDATE: 'system-config:update',   // 更新设置
    DELETE: 'system-config:delete',   // 删除设置
    EXPORT: 'system-config:export',   // 导出设置
    IMPORT: 'system-config:import',   // 导入设置
    DETAIL: 'system-config:detail',   // 设置详情
    CREATE: 'system-config:create',   // 创建设置
   
  },

  // 轮播图管理
  BANNER: {
    LIST: 'banner:list',       // 轮播图列表
    DETAIL: 'banner:detail',   // 轮播图详情
    CREATE: 'banner:create',   // 创建轮播图
    UPDATE: 'banner:update',   // 更新轮播图
    DELETE: 'banner:delete',   // 删除轮播图
  },
};

// 赏金平台管理按钮权限
export const REWARD = {

  
  // 用户管理
  USER: {
    LIST: 'reward:user:list',       // 用户列表
    DETAIL: 'reward:user:detail',   // 用户详情
    BLOCK: 'reward:user:block',     // 封禁用户
    UNBLOCK: 'reward:user:unblock', // 解封用户
  },
  
  // 财务管理
  FINANCE: {
    WITHDRAW: {
      LIST: 'reward:finance:withdraw:list',     // 提现列表
      AUDIT: 'reward:finance:withdraw:audit',   // 审核提现
    },
    TRANSACTION: {
      LIST: 'reward:finance:transaction:list',  // 交易记录列表
      DETAIL: 'reward:finance:transaction:detail', // 交易详情
    },
    ORDER: {
      LIST: 'reward:finance:order:list',        // 订单列表
      DETAIL: 'reward:finance:order:detail',    // 订单详情
      VERIFY: 'reward:finance:order:verify',    // 核定订单
    },
    PRECHARGE: {
      LIST: 'reward:finance:precharge:list',    // 预充值订单列表
      DETAIL: 'reward:finance:precharge:detail', // 预充值订单详情
      AUDIT: 'reward:finance:precharge:audit',  // 审核预充值订单
    },
  },
  
  // 认证管理
  VERIFICATION: {
    // 用户认证
    USER: {
      LIST: 'reward:verification:user:list',       // 用户认证列表
      DETAIL: 'reward:verification:user:detail',   // 用户认证详情
      AUDIT: 'reward:verification:user:audit',     // 审核用户认证
    },
    // 企业认证
    BUSINESS: {
      LIST: 'reward:verification:business:list',       // 企业认证列表
      DETAIL: 'reward:verification:business:detail',   // 企业认证详情
      AUDIT: 'reward:verification:business:audit',     // 审核企业认证
      QUEUE: 'reward:verification:business:queue',     // 企业认证审核队列
      QUEUE_MANAGE: 'reward:verification:business:queue:manage', // 管理审核队列
    },
  },
  
  // 用户账户管理
  ACCOUNT: {
    LIST: 'reward:account:list',       // 账户列表
    CREATE: 'reward:account:create',   // 创建账户
    UPDATE: 'reward:account:update',   // 更新账户
    DELETE: 'reward:account:delete',   // 删除账户
    DETAIL: 'reward:account:detail',   // 账户详情
    FREEZE: 'reward:account:freeze',   // 冻结账户
    UNFREEZE: 'reward:account:unfreeze', // 解冻账户
  },
  
 
  
  // 登录管理
  LOGIN: {
    LIST: 'reward:login:list',       // 登录列表
    DETAIL: 'reward:login:detail',   // 登录详情
  },
  
  // 设备管理
  DEVICE: {
    LIST: 'reward:device:list',       // 设备列表
    DETAIL: 'reward:device:detail',   // 设备详情
  },
  
  // 设备历史
  DEVICE_HISTORY: {
    LIST: 'reward:device:history:list',       // 设备历史列表
    DETAIL: 'reward:device:history:detail',   // 设备历史详情
  },
  
  // 订单管理
  ORDER: {
    LIST: 'reward:order:list',           // 订单列表
    DETAIL: 'reward:order:detail',       // 订单详情
    UPDATE: 'reward:order:update',       // 更新订单
    CANCEL: 'reward:order:cancel',       // 取消订单
    EXPORT: 'reward:order:export',       // 导出订单
  },
  
  // 预充值订单管理
  PRECHARGE: {
    LIST: 'reward:precharge:list',       // 预充值订单列表
    DETAIL: 'reward:precharge:detail',   // 预充值订单详情
    AUDIT: 'reward:precharge:audit',     // 审核预充值订单
    EXPORT: 'reward:precharge:export',   // 导出预充值订单
  },
  
  // 支付接口集成
  PAYMENT: {
    LIST: 'reward:payment:list',         // 支付接口列表
    CREATE: 'reward:payment:create',     // 创建支付接口
    UPDATE: 'reward:payment:update',     // 更新支付接口
    DELETE: 'reward:payment:delete',     // 删除支付接口
    DETAIL: 'reward:payment:detail',     // 支付接口详情
    ENABLE: 'reward:payment:enable',     // 启用支付接口
    DISABLE: 'reward:payment:disable',   // 禁用支付接口
  },
  
  // 账户冻结记录管理
  FREEZE_RECORD: {
    LIST: 'reward:freeze:record:list',       // 冻结记录列表
    DETAIL: 'reward:freeze:record:detail',   // 冻结记录详情
    EXPORT: 'reward:freeze:record:export',   // 导出冻结记录
  },
};

// 仪表盘按钮权限
export const DASHBOARD = {
  VIEW: 'dashboard:view',           // 查看仪表盘
  EXPORT: 'dashboard:export',       // 导出仪表盘数据
};

// 个人中心权限
export const PROFILE = {
  VIEW: 'profile:view',             // 查看个人信息
  UPDATE: 'profile:update',         // 更新个人信息
  CHANGE_PWD: 'profile:change-password', // 修改密码
};

// 通信管理按钮权限
export const COMMUNICATION = {
  // 系统通知管理
  NOTIFICATION: {
    LIST: 'communication:notification:list',       // 通知列表
    CREATE: 'communication:notification:create',   // 创建通知
    UPDATE: 'communication:notification:update',   // 更新通知
    DELETE: 'communication:notification:delete',   // 删除通知
    DETAIL: 'communication:notification:detail',   // 通知详情
    SEND: 'communication:notification:send',       // 发送通知
    BATCH_SEND: 'communication:notification:batch-send', // 批量发送通知
    TEMPLATE: 'communication:notification:template', // 通知模板管理
  },
  
  // 聊天消息管理
  CHAT: {
    MESSAGE: {
      LIST: 'communication:chat:message:list',     // 消息列表
      DETAIL: 'communication:chat:message:detail', // 消息详情
      DELETE: 'communication:chat:message:delete', // 删除消息
      EXPORT: 'communication:chat:message:export', // 导出消息
    },
    SESSION: {
      LIST: 'communication:chat:session:list',     // 会话列表
      DETAIL: 'communication:chat:session:detail', // 会话详情
      CLOSE: 'communication:chat:session:close',   // 关闭会话
    },
    MEMBER: {
      LIST: 'communication:chat:member:list',      // 会话成员列表
      ADD: 'communication:chat:member:add',        // 添加会话成员
      REMOVE: 'communication:chat:member:remove',  // 移除会话成员
    }
  },
  
  // 消息推送管理
  PUSH: {
    LIST: 'communication:push:list',               // 推送列表
    CREATE: 'communication:push:create',           // 创建推送
    UPDATE: 'communication:push:update',           // 更新推送
    DELETE: 'communication:push:delete',           // 删除推送
    DETAIL: 'communication:push:detail',           // 推送详情
    SEND: 'communication:push:send',               // 发送推送
    TEMPLATE: 'communication:push:template',       // 推送模板管理
    CONFIG: 'communication:push:config',           // 推送配置管理
    STATS: 'communication:push:stats',             // 推送统计
    BATCH_SEND: 'communication:push:batch-send',   // 批量发送推送
  }
};

// 求购与动态按钮权限
export const PURCHASE_AND_DYNAMICS = {
  PURCHASE: {
    LIST: 'purchase:list',       // 求购列表
    CREATE: 'purchase:create',   // 创建求购
    UPDATE: 'purchase:update',   // 更新求购
    DELETE: 'purchase:delete',   // 删除求购
    DETAIL: 'purchase:detail',   // 求购详情
  },
  DYNAMICS: {
    LIST: 'dynamics:list',       // 动态列表
    CREATE: 'dynamics:create',   // 创建动态
    UPDATE: 'dynamics:update',   // 更新动态
    DELETE: 'dynamics:delete',   // 删除动态
    DETAIL: 'dynamics:detail',   // 动态详情
  }
};

// 服务管理按钮权限
export const SERVICE_MANAGEMENT = {
  // 定制服务权限
  CUSTOM_SERVICE: {
    LIST: 'service:custom:list',       // 定制服务列表
    CREATE: 'service:custom:create',   // 创建定制服务
    UPDATE: 'service:custom:update',   // 更新定制服务
    DELETE: 'service:custom:delete',   // 删除定制服务
    DETAIL: 'service:custom:detail',   // 定制服务详情
  },
  
  // 陪逛服务权限
  ACCOMPANY_SERVICE: {
    LIST: 'service:accompany:list',       // 陪逛服务列表
    CREATE: 'service:accompany:create',   // 创建陪逛服务
    UPDATE: 'service:accompany:update',   // 更新陪逛服务
    DELETE: 'service:accompany:delete',   // 删除陪逛服务
    DETAIL: 'service:accompany:detail',   // 陪逛服务详情
  },
  
  // 定制服务请求权限
  CUSTOM_SERVICE_REQUEST: {
    LIST: 'service:custom:request:list',       // 定制服务请求列表
    DETAIL: 'service:custom:request:detail',   // 定制服务请求详情
    QUOTE: 'service:custom:request:quote',     // 定制服务请求报价
    UPDATE_STATUS: 'service:custom:request:update-status', // 更新定制服务请求状态
    CANCEL: 'service:custom:request:cancel',   // 取消定制服务请求
  },
  
  // 定制服务订单权限
  CUSTOM_SERVICE_ORDER: {
    LIST: 'service:custom:order:list',       // 定制服务订单列表
    DETAIL: 'service:custom:order:detail',   // 定制服务订单详情
    ASSIGN: 'service:custom:order:assign',   // 分配管理员
    UPDATE_STATUS: 'service:custom:order:update-status', // 更新订单状态
    SET_DELIVERY_TIME: 'service:custom:order:set-delivery-time', // 设置交付时间
    COMPLETE: 'service:custom:order:complete', // 完成订单
    CANCEL: 'service:custom:order:cancel',   // 取消订单
  },
  
  // 陪逛服务售后权限
  ACCOMPANY_SHOPPING_AFTER_SALE: {
    LIST: 'service:accompany:after-sale:list',       // 售后服务列表
    DETAIL: 'service:accompany:after-sale:detail',   // 售后服务详情
    HANDLE: 'service:accompany:after-sale:handle',   // 处理售后服务
    UPDATE_STATUS: 'service:accompany:after-sale:update-status', // 更新售后服务状态
    COMPLETE: 'service:accompany:after-sale:complete', // 完成售后服务
    REJECT: 'service:accompany:after-sale:reject',   // 拒绝售后服务
  },
  
  // 售后服务权限
  AFTER_SALE_SERVICE: {
    LIST: 'service:after-sale:list',       // 售后服务列表
    DETAIL: 'service:after-sale:detail',   // 售后服务详情
    AUDIT: 'service:after-sale:audit',     // 审核售后服务
    PROCESS: 'service:after-sale:process', // 处理售后服务
    COMPLETE: 'service:after-sale:complete', // 完成售后服务
    REJECT: 'service:after-sale:reject',   // 拒绝售后服务
  }
};

// 帮助中心按钮权限
export const HELP_CENTER = {
  CATEGORY_MANAGEMENT: {
    LIST: 'help_center_category:list',
    CREATE: 'help_center_category:create',
    UPDATE: 'help_center_category:update',
    DELETE: 'help_center_category:delete',
    TOGGLE_STATUS: 'help_center_category:toggle_status'
  },
  ARTICLE_MANAGEMENT: {
    LIST: 'help_center_article:list',
    CREATE: 'help_center_article:create',
    UPDATE: 'help_center_article:update',
    DELETE: 'help_center_article:delete',
    PUBLISH: 'help_center_article:publish'
  }
};

// 商品管理按钮权限
export const PRODUCT_MANAGEMENT = {
  // 现有的权限
  CATEGORY_MANAGEMENT: {
    LIST: 'category:list',
    CREATE: 'category:add',
    UPDATE: 'category:update',
    DELETE: 'category:delete'
  },
  GOODS_MANAGEMENT: {
    LIST: 'goods:list',
    CREATE: 'goods:create',
    UPDATE: 'goods:update',
    DELETE: 'goods:delete',
    TOGGLE_STATUS: 'goods:toggle_status'
  },
  // 新增商品审核队列权限
  GOODS_AUDIT_QUEUE: {
    LIST: 'goods-audit-queue:list',
    DETAIL: 'goods-audit-queue:detail',
    AUDIT: 'goods-audit-queue:update'
  },
  // 新增商品评论权限
  GOODS_COMMENT: {
    LIST: 'goods-comment:list',
    CREATE: 'goods-comment:create',
    UPDATE: 'goods-comment:update',
    DETAIL: 'goods-comment:detail',
    DELETE: 'goods-comment:delete'
  },
  // 新增商品规格类型权限
  GOODS_SPEC_TYPE: {
    LIST: 'goods-spec-type:list',
    CREATE: 'goods-spec-type:create',
    UPDATE: 'goods-spec-type:update',
    DELETE: 'goods-spec-type:delete'
  },

 //售后服务管理权限
 AFTER_SALE_SERVICE_MANAGEMENT: {
  LIST: 'after-sale-service:list',
  DETAIL: 'after-sale-service:detail',
  AUDIT: 'after-sale-service:audit',
 
 },

 //订单列表权限
 ORDER_LIST: {
  LIST: 'goods-order:list',
  DETAIL: 'goods-order:detail',
  DELETE: 'goods-order:delete'
 }
 
 
};
export const SHOP_MANAGEMENT = {
  STORE: {
    LIST: 'store:list',
    CREATE: 'store:add',
    UPDATE: 'store:update',
    DELETE: 'store:delete',
    DETAIL: 'store:detail',
    TOGGLE_STATUS: 'store:update'
  },
  MERCHANT_ENTRY_APPLICATION: {
    LIST: 'merchant-entry:list',
    DETAIL: 'merchant-entry:detail',
    AUDIT: 'merchant-entry:audit'
  },
  MERCHANT_QUALIFICATION: {
    LIST: 'merchant-qualification:list',
    DETAIL: 'merchant-qualification:detail',
    STATUS: 'merchant-qualification:toggle-status'
  },
  MERCHANT_CERTIFICATION: {
    LIST: 'merchant-certification:list',
    DETAIL: 'merchant-certification:detail',
    AUDIT: 'merchant-certification:audit'
  },
  MERCHANT_BUSINESS_INFO: {
    LIST: 'merchant-business-info:list',
    DETAIL: 'merchant-business-info:detail',
    ADD: 'merchant-business-info:add',
    UPDATE: 'merchant-business-info:update',
    DELETE: 'merchant-business-info:delete'
  }
};

export const LOGISTICS_MANAGEMENT = {
  LOGISTICS_COMPANY: {
    LIST: 'logistics-company:list',
    DETAIL: 'logistics-company:detail',
    ADD: 'logistics-company:add',
    UPDATE: 'logistics-company:update',
    DELETE: 'logistics-company:delete'
  },

  AFTER_SALE_SERVICE_CONFIG: {
    LIST: 'after-sale-service-config:list',
    DETAIL: 'after-sale-service-config:detail',
    ADD: 'after-sale-service-config:add',
    UPDATE: 'after-sale-service-config:update',
    DELETE: 'after-sale-service-config:delete'
  },

  FREIGHT_TEMPLATE: {
    LIST: 'freight-template:list',
    DETAIL: 'freight-template:detail',
    ADD: 'freight-template:add',
    UPDATE: 'freight-template:update',
    DELETE: 'freight-template:delete'
  },

  FREIGHT_TEMPLATE_RULE: {
    LIST: 'freight-template-rule:list',
    DETAIL: 'freight-template-rule:detail',
    ADD: 'freight-template-rule:create',
    UPDATE: 'freight-template-rule:update',
    DELETE: 'freight-template-rule:delete'
  },

  REGION: {
    LIST: 'region:list',
    DETAIL: 'region:detail',
    ADD: 'region:create',
    UPDATE: 'region:update',
    DELETE: 'region:delete'
  },

  SENDER_INFO: {
    LIST: 'sender:list',
    DETAIL: 'sender:detail',
    ADD: 'sender:create',
    UPDATE: 'sender:update',
    DELETE: 'sender:delete'
  },

  AFTER_SALES_TYPE: {
    LIST: 'after-sales-type:list',
    DETAIL: 'after-sales-type:detail',
    ADD: 'after-sales-type:create',
    UPDATE: 'after-sales-type:update',
    DELETE: 'after-sales-type:delete'
  }


};
export const USER_MANAGEMENT = {
  USER_ADDRESS: {
    LIST: 'address:list',
    DETAIL: 'address:detail',
    DELETE: 'address:delete',
    UPDATE: 'address:update'
  }
};
export const ACCOMPANY_SHOPPING_LOCATION_MANAGEMENT = {
  LIST: 'location:list',
  DETAIL: 'location:detail',
  ADD: 'location:create',
  UPDATE: 'location:update',
  DELETE: 'location:delete'
};
//陪逛服务提供者申请管理权限
export const ACCOMPANY_SHOPPING_PROVIDER_APPLICATION_MANAGEMENT = {
  LIST: 'accompany-shopping-provider-application:list',
  DETAIL: 'accompany-shopping-provider-application:detail',
  AUDIT: 'accompany-shopping-provider-application:review'
};
 //陪逛服务评价管理权限
export const ACCOMPANY_SHOPPING_REVIEW_MANAGEMENT = {
  LIST: 'accompany-shopping-review:list',
  DETAIL: 'accompany-shopping-review:detail',
  DELETE: 'accompany-shopping-review:delete'
};


//定制服务订单管理权限
export const CUSTOM_SERVICE_ORDER_MANAGEMENT = {
  LIST: 'custom-service-order:list',
  DETAIL: 'custom-service-order:detail',
  DELETE: 'custom-service-order:delete'
};


//定制服务需求管理权限
export const CUSTOM_SERVICE_REQUEST_MANAGEMENT = {
  LIST: 'custom-service-request:list',
  DETAIL: 'custom-service-request:detail',
  DELETE: 'custom-service-request:delete',
  UPDATE: 'custom-service-request:update',
  START_SERVICE: 'custom-service-request:start-service',
  COMPLETE_SERVICE: 'custom-service-request:complete-service',
  REVIEW: 'custom-service-request:review',
  CREATE: 'custom-service-request:create'
};


//平台代售订单管理权限
export const PLATFORM_SALES_ORDER_MANAGEMENT = {
  LIST: 'platform-sales-order:list',
  DETAIL: 'platform-sales-order:detail',
  DELETE: 'platform-sales-order:delete',
  ACCEPT: 'platform-sales-order:accept',
  REJECT: 'platform-sales-order:reject',
  CONFIRM: 'platform-sales-order:confirm',
};


//平台代售商品管理权限
export const PLATFORM_SALES_PRODUCT_MANAGEMENT = {
  LIST: 'platform-sales-product:list',
  DETAIL: 'platform-sales-product:detail',
  DELETE: 'platform-sales-product:delete',
  UPDATE: 'platform-sales-product:update',
  CREATE: 'platform-sales-product:create'
};

//平台代售物流管理权限
export const PLATFORM_SALES_RETURN_MANAGEMENT = {
  LIST: 'platform-sales-return:list',
  DETAIL: 'platform-sales-return:detail',
  DELETE: 'platform-sales-return:delete',
  UPDATE: 'platform-sales-return:update',
  CREATE: 'platform-sales-return:create'
};

//平台代售物流管理权限
export const PLATFORM_SALES_SHIPPING_MANAGEMENT = {
  LIST: 'platform-sales-shipping:list',
  DETAIL: 'platform-sales-shipping:detail',
  DELETE: 'platform-sales-shipping:delete',
  UPDATE: 'platform-sales-shipping:update',
  CREATE: 'platform-sales-shipping:create'
};

// 资讯管理按钮权限
export const ARTICLE_MANAGEMENT = {
  ARTICLE: {
    LIST: 'article:list',
    CREATE: 'article:create',
    UPDATE: 'article:update',
    DELETE: 'article:delete',
    DETAIL: 'article:detail'
  },
  ARTICLE_TYPE: {
    LIST: 'article-type:list',
    CREATE: 'article-type:create',
    UPDATE: 'article-type:update',
    DELETE: 'article-type:delete',
    DETAIL: 'article-type:detail'
  }
};

//提现记录
export const WITHDRAW_RECORD = {
  LIST: 'withdraw-record:list',
  DETAIL: 'withdraw-record:detail',
  AUDIT: 'withdraw-record:audit',
  UPDATE: 'withdraw-record:update',
  DELETE: 'withdraw-record:delete'
};
// 提现配置按钮权限
export const WITHDRAW_CONFIG = {
  LIST: 'withdraw-config:list',
  DETAIL: 'withdraw-config:detail',
  UPDATE: 'withdraw-config:update',
  DELETE: 'withdraw-config:delete'
};

// 用户提现配置按钮权限
export const USER_WITHDRAW_CONFIG = {
  LIST: 'withdraw:list',
  DETAIL: 'withdraw:detail',
  UPDATE: 'withdraw:update',
  DELETE: 'withdraw:delete'
};

// 交易记录按钮权限
export const TRANSACTION_RECORD = {
  LIST: 'transaction:list',
  DETAIL: 'transaction:detail',
  AUDIT: 'transaction:audit',
  UPDATE: 'transaction:update',
  DELETE: 'transaction:delete'
};

// 支付订单按钮权限
export const PAYMENT_ORDER = {
  LIST: 'payment:list',
  DETAIL: 'payment:detail',
  AUDIT: 'payment:audit',
  UPDATE: 'payment:update',
  DELETE: 'payment:delete'
};

// 账户冻结记录按钮权限
export const ACCOUNT_FREEZE_RECORD = {
  LIST: 'account:freeze:record:list',
  DETAIL: 'account:freeze:record:detail',
  AUDIT: 'account:freeze:record:audit',
  UPDATE: 'account:freeze:record:update',
  DELETE: 'account:freeze:record:delete'
};

// 支付接口集成按钮权限
export const PAYMENT_INTEGRATION = {
  LIST: 'payment:integration:list',
  DETAIL: 'payment:integration:detail',
  AUDIT: 'payment:integration:audit',
  UPDATE: 'payment:integration:update',
  DELETE: 'payment:integration:delete'
};

//求购列表
export const PURCHASE_LIST = {
  LIST: 'buying-post:list',
  DETAIL: 'purchase:detail',
  DELETE: 'buying-post:delete',
  UPDATE: 'buying-post:update',
  CREATE: 'buying-post:create'
};

//求购审核队列
export const PURCHASE_AUDIT_QUEUE = {
  LIST: 'buying-post-audit-queue:list',
  DETAIL: 'buying-post-audit-queue:detail',
  DELETE: 'buying-post-audit-queue:delete',
  AUDIT: 'buying-post-audit-queue:audit'
};



//动态列表
export const DYNAMICS_LIST = {
  LIST: 'moment-post:list',
  DETAIL: 'moment-post:detail',
  DELETE: 'moment-post:delete',
  UPDATE: 'moment-post:update',
  CREATE: 'moment-post:create'
};

//动态审核队列
export const DYNAMICS_AUDIT_QUEUE = {
  LIST: 'moment-post-audit-queue:list',
  DETAIL: 'moment-post-audit-queue:detail',
  DELETE: 'moment-post-audit-queue:delete',
  AUDIT: 'moment-post-audit-queue:audit'
};

//系统通知
export const SYSTEM_NOTIFICATION = {
  LIST: 'communication:notification:list',
  DETAIL: 'communication:notification:detail',
  DELETE: 'communication:notification:delete',
  UPDATE: 'communication:notification:update',
  CREATE: 'communication:notification:create'
};

//聊天消息
export const CHAT_MESSAGE = {
  LIST: 'communication:chat:message:list',
  DETAIL: 'communication:chat:message:detail',
  DELETE: 'communication:chat:message:delete',
  UPDATE: 'communication:chat:message:update',
  CREATE: 'communication:chat:message:create'
};

//聊天会话
export const CHAT_SESSION = {
  LIST: 'system:chat:session:list',
  DETAIL: 'system:chat:session:detail',
  DELETE: 'system:chat:session:delete',
  UPDATE: 'system:chat:session:update',
  CREATE: 'system:chat:session:create'
};

//投诉反馈
export const COMPLAINT_FEEDBACK = {
  LIST: 'complaint-feedback:list',
  DETAIL: 'complaint-feedback:detail',
  DELETE: 'complaint-feedback:delete',
  UPDATE: 'complaint-feedback:update',
  CREATE: 'complaint-feedback:create'
};

//投诉类型配置
export const COMPLAINT_TYPE_CONFIG = {
  LIST: 'complaint-type-config:list',
  DETAIL: 'complaint-type-config:detail',
  DELETE: 'complaint-type-config:delete',
  UPDATE: 'complaint-type-config:update',
  CREATE: 'complaint-type-config:create'
};

//帮助中心文章
export const HELP_CENTER_ARTICLE = {
  LIST: 'help-center-article:list',
  DETAIL: 'help-center-article:detail',
  DELETE: 'help-center-article:delete',
  UPDATE: 'help-center-article:update',
  UPDATE_STATUS: 'help-center-article:update-status',
  CREATE: 'help-center-article:create'
};

//帮助中心分类
export const HELP_CENTER_CATEGORY = {
  LIST: 'help-center-category:list',
  DETAIL: 'help-center-category:detail',
  DELETE: 'help-center-category:delete',
  UPDATE: 'help-center-category:update',
  CREATE: 'help-center-category:create'
};


// 资讯文章
export const ARTICLE = {
  LIST: 'article:list',
  DETAIL: 'article:detail',
  DELETE: 'article:delete',
  UPDATE: 'article:update',
  CREATE: 'article:create'
};

// 玉石鉴定知识文章
export const JADE_IDENTIFICATION_ARTICLE = {
  LIST: 'jade-identification-article:list',
  DETAIL: 'jade-identification-article:detail',
  CREATE: 'jade-identification-article:create',
  UPDATE: 'jade-identification-article:update',
  DELETE: 'jade-identification-article:delete'
};

//资讯文章类型
export const ARTICLE_TYPE = {
  LIST: 'article-type:list',
  DETAIL: 'article-type:detail',
  DELETE: 'article-type:delete',
  UPDATE: 'article-type:update',
  CREATE: 'article-type:create'
};

//店铺访问统计
export const STORE_VISIT_STATISTICS = {
  LIST: 'store-visit-statistics:list',
  DETAIL: 'store-visit-statistics:detail',
  DELETE: 'store-visit-statistics:delete',
  COUNT: 'store-visit-statistics:count'
};

// 付费文章兑换码管理按钮权限
export const ARTICLE_REDEEM_CODE = {
  LIST: 'article-redeem-code:list',
  DETAIL: 'article-redeem-code:detail',
  CREATE: 'article-redeem-code:create',
  UPDATE: 'article-redeem-code:update',
  DELETE: 'article-redeem-code:delete'
};

// 用户付费文章服务兑换管理按钮权限
export const USER_ARTICLE_REDEEM = {
  LIST: 'user-article-redeem:list',
  DETAIL: 'user-article-redeem:detail',
  CREATE: 'user-article-redeem:create',
  UPDATE: 'user-article-redeem:update',
  DELETE: 'user-article-redeem:delete'
};

// 玉石鉴定服务管理按钮权限
export const JADE_IDENTIFICATION_SERVICE = {
  LIST: 'jade-identification-service:list',
  DETAIL: 'jade-identification-service:detail',
  CREATE: 'jade-identification-service:create',
  UPDATE: 'jade-identification-service:update',
  DELETE: 'jade-identification-service:delete'
};

// 玉石鉴定分类管理按钮权限
export const JADE_IDENTIFICATION_CATEGORY = {
  LIST: 'jade-identification-category:list',
  DETAIL: 'jade-identification-category:detail',
  ADD: 'jade-identification-category:add',
  UPDATE: 'jade-identification-category:update',
  DELETE: 'jade-identification-category:delete'
};

// 玉石鉴定订单管理按钮权限
export const JADE_IDENTIFICATION_ORDER = {
  LIST: 'jade-identification-order:list',
  DETAIL: 'jade-identification-order:detail',
  ADD: 'jade-identification-order:add',
  UPDATE: 'jade-identification-order:update',
  DELETE: 'jade-identification-order:delete'
};

// 所有权限集合
export default {
  MENU,
  SYSTEM,
  REWARD,
  DASHBOARD,
  PROFILE,
  COMMUNICATION, // 添加通信管理权限
  PURCHASE_AND_DYNAMICS, // 添加求购与动态权限
  SERVICE_MANAGEMENT, // 添加服务管理权限
  HELP_CENTER, // 添加帮助中心权限
  PRODUCT_MANAGEMENT, // 添加商品管理权限
  SHOP_MANAGEMENT, // 添加店铺管理权限
  LOGISTICS_MANAGEMENT, // 添加物流公司管理权限
  USER_MANAGEMENT, // 添加用户地址管理权限
  ARTICLE_MANAGEMENT, // 添加资讯管理权限
  STORE_VISIT_STATISTICS, // 添加店铺访问统计权限
  JADE_IDENTIFICATION_SERVICE, // 添加玉石鉴定服务管理权限
  JADE_IDENTIFICATION_CATEGORY, // 添加玉石鉴定分类管理权限
  JADE_IDENTIFICATION_ORDER, // 添加玉石鉴定订单管理权限
  USER_ARTICLE_REDEEM // 添加用户付费文章服务兑换管理权限
};